import { render, staticRenderFns } from "./LocationSection.vue?vue&type=template&id=63bb1ab6&scoped=true"
import script from "./LocationSection.vue?vue&type=script&lang=js"
export * from "./LocationSection.vue?vue&type=script&lang=js"
import style0 from "./LocationSection.vue?vue&type=style&index=0&id=63bb1ab6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63bb1ab6",
  null
  
)

export default component.exports